import { ROLE } from '@/access/roles';

import type { Role } from '@/access/roles';

export const DOCUMENTATION_AUDIENCE: Role[] = [ROLE.USER, ROLE.CONTENT_CREATOR];
